import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router'


@Injectable({
  providedIn: 'root'
})

export class ProfileService {
  baseUrl = environment.baseUrl;
  test:any;
  ProfileData:any;
  constructor(private _httpClient: HttpClient,
    private router: Router,) { }


   resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {

            Promise.all([
                this.getProfile()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }
    // 
    getProfile(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'user/profile')
                .subscribe((response: any) => {
                    console.log('profile', response)
                    this.ProfileData = response.data
                    resolve(response);
                }, reject);
        });
    } 

    updateProfile(data): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.put(this.baseUrl + 'user/profile',data)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    } 

    
   changePassword(data): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.put(this.baseUrl + 'user/change/password',data)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    } 
  
}
